import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[woMultiSelectGroupLabel]',
  standalone: true,
})
export class MultiSelectGroupLabelDirective {
  public readonly template = inject(TemplateRef);
}
